import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { DISPLAY_LOADER } from '@banyan/commons/contexts/httpContextToken.context';
import { ProgressSpinnerService } from '@banyan/commons/services/progress-spinner.service';
import { finalize } from 'rxjs';

export function loaderInterceptor(req: HttpRequest<any>, next: HttpHandlerFn) {
  return _loaderInterceptor(inject(ProgressSpinnerService))(req, next);
}

export function _loaderInterceptor(progressSpinnerService: ProgressSpinnerService) {
  return (req: HttpRequest<any>, next: HttpHandlerFn) => {
    if (req.context.get(DISPLAY_LOADER)) {
      progressSpinnerService.show();
    }

    return next(req).pipe(
      finalize(() => {
        if (req.context.get(DISPLAY_LOADER)) {
          progressSpinnerService.hide();
        }
      }),
    );
  };
}
